export const removeLeadingZeros = (input) => {
    const numberValue = Number(input);
    return numberValue === 0 ? "0" : String(numberValue).replace(/^0+/, "");
  };
  